import script from "./AddElementModal.vue?vue&type=script&lang=ts&setup=true"
export * from "./AddElementModal.vue?vue&type=script&lang=ts&setup=true"

import "./AddElementModal.vue?vue&type=style&index=0&id=acb3bc0a&lang=scss&scoped=true"

import exportComponent from "D:\\huishi-ppt\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-acb3bc0a"]])

export default __exports__